import React from 'react';
import Navbar from './Navbar';

const Contact = () => {
  return(
    <React.Fragment>
      <Navbar/>
      <section className="section">
        <h1 className="section__title">Contact</h1>
      </section>
    </React.Fragment>
  );
}

export default Contact;


// WEBPACK FOOTER //
// ./src/components/Contact.js